<template>
  <div class="heatmap-container right-column">
    <div class="heatmap-inner">
      <category-row v-for="(category, index) in state.categories" :key="category.name | makeID"
        :category="category"
        :riskData="timeBlock"
        :catIndex="index"></category-row>
    </div>
  </div>
</template>

<script>
import YearColumn from './YearColumn';
import MapCategoryRow from './MapCategoryRow';

export default {
  name: 'heatmap',
  props: ['timeBlock', 'state'],
  components: {
    'year-column': YearColumn,
    'category-row': MapCategoryRow,
  },
};
</script>

<style lang="less">
  .heatmap-container {
   display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// HeatMapGraphic.vue?56eb5c34